import { Injectable, Pipe, PipeTransform } from '@angular/core'
import { NationsService } from 'src/app/core/services/nations.service'

@Pipe({
  name: 'flag',
  standalone: true,
  pure: true, 
})
@Injectable({ providedIn: 'root' })
export class FlagPipe implements PipeTransform {
  baseURL = '/flagsapi/'
  
  constructor(private nationsService: NationsService) {}

  transform(nation: string): string {
    switch(nation){
      case "Kosovo": return 'https://atleticostats.fra1.digitaloceanspaces.com/logos/Kosovo.png'
      case "England": return 'https://atleticostats.fra1.digitaloceanspaces.com/logos/England.png'
      case "Guadeloupe": return 'https://atleticostats.fra1.cdn.digitaloceanspaces.com/logos/Guadaloupe.png'
      case "Northern Ireland": return 'https://atleticostats.fra1.digitaloceanspaces.com/logos/NorthernIreland.png'
      case "Wales": return 'https://atleticostats.fra1.digitaloceanspaces.com/logos/Wales.png'
      case "Scotland": return 'https://atleticostats.fra1.digitaloceanspaces.com/logos/Scotland.png'
    }
    return this.baseURL + this.nationsService.countryMap[nation] + '/flat/64.png'
  }
}